import { useAuth0 } from "@auth0/auth0-react";
import { CircularProgress } from "@mui/material";
import { LoginContainer } from "components/LoginContainer";
import { FC, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "store";
import { selectAuth, selectAuth0 } from "store/slices/user.store";

export const Auth0Login: FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated, loginWithRedirect, isLoading, error } = useAuth0();
  const auth0Var = useAppSelector(selectAuth0);
  const authVar = useAppSelector(selectAuth);

  useEffect(() => {
    if (!isLoading && (!authVar.isLoggedIn || !isAuthenticated) && !error) {
      loginWithRedirect({ login_hint: auth0Var.email });
    } else if (!isLoading && isAuthenticated && authVar.isLoggedIn) {
      navigate("/jobs", { replace: true });
    }
  }, [
    isAuthenticated,
    isLoading,
    loginWithRedirect,
    error,
    auth0Var.email,
    navigate,
    authVar.isLoggedIn,
  ]);

  return (
    <LoginContainer>
      <CircularProgress size={24} />
    </LoginContainer>
  );
};
